import { useState } from 'react';

interface TopBarProps {
  onLogout: () => void;
}

export default function TopBar({ onLogout }: TopBarProps) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const currentTime = new Date().toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  return (
    <header className="h-16 bg-gray-900 border-b border-teal-500/20 flex items-center justify-between px-6">
      {/* 左侧 - 面包屑导航 */}
      <div className="flex items-center gap-4">
        <h2 className="text-white font-medium text-lg">智创灵眸无人机管理平台</h2>
        <div className="flex items-center gap-2 text-sm text-gray-400">
          <i className="ri-time-line"></i>
          <span>{currentTime}</span>
        </div>
      </div>

      {/* 右侧 - 用户信息和操作 */}
      <div className="flex items-center gap-4">
        {/* 通知 */}
        <button className="relative p-2 text-gray-400 hover:text-white transition-colors cursor-pointer">
          <i className="ri-notification-3-line text-xl"></i>
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        {/* 设置 */}
        <button className="p-2 text-gray-400 hover:text-white transition-colors cursor-pointer">
          <i className="ri-settings-3-line text-xl"></i>
        </button>

        {/* 分割线 */}
        <div className="w-px h-6 bg-gray-700"></div>

        {/* 用户信息 */}
        <div className="relative">
          <button
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-800 transition-colors cursor-pointer"
          >
            <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center">
              <i className="ri-user-line text-white text-sm"></i>
            </div>
            <div className="text-left">
              <div className="text-sm text-white font-medium">管理员</div>
              <div className="text-xs text-gray-400">admin@port.com</div>
            </div>
            <i className={`ri-arrow-${showUserMenu ? 'up' : 'down'}-s-line text-gray-400`}></i>
          </button>

          {/* 下拉菜单 */}
          {showUserMenu && (
            <div className="absolute right-0 top-full mt-2 w-48 bg-gray-800 border border-teal-500/20 rounded-lg shadow-xl overflow-hidden z-50">
              <button className="w-full px-4 py-3 text-left text-sm text-gray-300 hover:bg-gray-700 transition-colors flex items-center gap-3 cursor-pointer">
                <i className="ri-user-settings-line"></i>
                个人设置
              </button>
              <button className="w-full px-4 py-3 text-left text-sm text-gray-300 hover:bg-gray-700 transition-colors flex items-center gap-3 cursor-pointer">
                <i className="ri-lock-password-line"></i>
                修改密码
              </button>
              <div className="border-t border-gray-700"></div>
              <button
                onClick={onLogout}
                className="w-full px-4 py-3 text-left text-sm text-red-400 hover:bg-gray-700 transition-colors flex items-center gap-3 cursor-pointer"
              >
                <i className="ri-logout-box-line"></i>
                退出登录
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}